import React from 'react'
import './header.css'
import CTA from './CTA'
import ImageWithLoading from '../ImageWithLoading'
import ME from '../../assets/me.png'
import HeaderSocial from './HeaderSocials'

const Header = () => {
    return (
        <header>
            <div className="container header__container">
                <h5>Hello I'm</h5>
                <h1>Akio Fujita</h1>
                <h5 className="text-light">Software Engineer @ Deloitte</h5>
                <CTA/>
                <HeaderSocial/>

                <div className='me'>
                    <ImageWithLoading 
                        src={ME} 
                        alt='Akio Fujita - Software Engineer'
                        className="header-image"
                    />
                </div>

                <a href="#contact" className='scroll__down'>Scroll Down</a>
            </div>
        </header>
    )
}

export default Header
